import React from 'react';
import './ContactUs.css';

import facultyPhoto from '../assets/hod_image.jpg'; 

const ContactUs = () => {
  return (
    <div className="contact-us-container" id="contact">
      <h1 className="contact-title">Contact Us</h1>
      <div className="contact-card">
        <div className="profile-pic-container">
          <img src={facultyPhoto} alt="Faculty Sponsor" className="profile-pic" />
        </div>
        <div className="contact-details">
          <h2>Dr. Nita M. Thakare</h2>
          <p>Faculty Sponsor</p>
          <p>ACM-W PCE Nagpur</p>
          <p>+91 9970575309</p>
          <p>
            <a href="mailto:nita.thakare@gmail.com">nita.thakare@gmail.com</a>
          </p>
        </div>
      </div>
      <div className="help-box">
        <h3>We Are Here to Help!</h3>
        <p>Feel free to reach out for any inquiries or support. We're always ready to assist you!</p>
      </div>
    </div>
  );
};

export default ContactUs;